
export function useLoginAPI() {
  const { request } = useRequestV2();
  const platformStore = usePlatformStore();

  async function authenticate(requestBody: AuthenticateRequest) {
    const url = 'V3/Login/Authenticate';
    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody,
      isAnonymous: true
    };

    return await request<LoginResponse>(url, requestOptions);
  }

  async function refreshAccessToken(requestBody: RefreshTokenRequest, softwareVersion: string) {

    const url = `V3/Login/RefreshAccessToken/?softwareVersion=${softwareVersion}`;

    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody,
      isAnonymous: true
    };

    return await request<RefreshTokensResponse>(url, requestOptions);
  }

  async function mfaCode(requestBody: MfaCodeRequest) {
    const url = 'V3/Login/MfaCode/';

    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody
    };

    return await request<MfaCodeResponse>(url, requestOptions);
  }

  async function checkAppVersion() {
    const softwareVersion = await platformStore.getSoftwareVersion();
    const url = `V3/Login/VersionCheck?appVersion=${softwareVersion}`;

    const requestOptions: RequestOptions = {
      isAnonymous: true
    };

    return await request<string>(url, requestOptions);
  }

  async function resetPassword(requestBody: ResetPasswordRequest) {
    const url = 'V3/Login/ResetPassword';
    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody,
      isAnonymous: true
    };

    return await request<ResetPasswordResponse>(url, requestOptions);
  }

  async function isUserLocked(username: string) {
    const url = `V3/Login/IsUserLocked/?username=${username}`;

    return await request<boolean>(url);

  }

  return {
    authenticate,
    refreshAccessToken,
    mfaCode,
    checkAppVersion,
    resetPassword,
    isUserLocked
  };
}
